module.exports = __webpack_public_path__ + "images/psp/Icon/improper-support.svg";